if (!customElements.get('leap-embroidery')) {
  customElements.define('leap-embroidery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('input');
      this.fields = this.querySelector('[data-name-fields]');
      this.config = JSON.parse(this.querySelector('[data-embroidery-config]').textContent);
      this.section = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || !this.section) return;
      this.section.classList.add('leap-product--embroidery');
      this.input.addEventListener('input', (event) => {
        if (!event.isComposing) this.normalize();
      }, options);
      this.input.addEventListener('compositionend', () => this.normalize(), options);
      this.section.addEventListener('change', () => this.sync(), options);
      document.addEventListener('submit', (event) => {
        // The sticky cart must use the same properties and validation as the main form.
        if (event.target.id === `${this.dataset.formId}--alt`) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.requestSubmit();
          return;
        }
        if (event.target !== this.form) return;
        this.sync();
        this.normalize();
        if (!this.input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
        }
      }, { ...options, capture: true });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    normalize() {
      const start = this.input.selectionStart;
      const end = this.input.selectionEnd;
      const value = this.input.value;
      this.input.value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      this.input.setSelectionRange(start, end);
      this.input.setCustomValidity(
        this.input.value && !/^[A-Z][a-z]{0,7}$/.test(this.input.value)
          ? '半角英字8文字以内で入力してください（例：Momo）。' : ''
      );
    }
    sync() {
      const id = this.form.querySelector('[name="id"]').value;
      const variant = this.config.variants.find((item) => String(item.id) === id);
      const required = this.config.optionIndex >= 0 && variant?.options[this.config.optionIndex] === this.config.yesValue;
      this.fields.hidden = !required;
      this.input.disabled = !required;
      this.input.required = required;
      if (!required) this.input.setCustomValidity('');
    }
  });
}
